import * as React from 'react';
import { FC } from 'react';

import {
  ButtonWrapper,
  Container,
  DescriptionTextBlock,
  HeadingText,
  ImageContainer,
  StyledButton,
  TitleText,
} from './empty-state.styled';
import { IEmptyStateProps } from './types';

const EmptyState: FC<IEmptyStateProps> = ({
  content: { image, headerText, title, description, buttonAction },
}) => {
  const mainImage = image?.locale?.app;
  const header = headerText?.locale;
  const titleText = title?.locale;
  const descriptionContent = description?.locale;

  return (
    <Container>
      {header && <HeadingText>{header}</HeadingText>}
      {mainImage && (
        <ImageContainer
          image={mainImage}
          alt={image?.locale?.imageDescription || 'Empty Image'}
          objectFitContain
        />
      )}
      {titleText && <TitleText>{titleText}</TitleText>}
      {descriptionContent && <DescriptionTextBlock content={descriptionContent} />}
      {buttonAction?.actionText && (
        <ButtonWrapper>
          <StyledButton to={buttonAction.actionUrl?.locale || ''}>
            {buttonAction.actionText.locale}
          </StyledButton>
        </ButtonWrapper>
      )}
    </Container>
  );
};

export default EmptyState;
